module.exports = __webpack_public_path__ + "img/en.0cf89fe6.svg";